module.exports = __webpack_public_path__ + "assets-cabinet/img/delete-icon.8838ee41.svg";